import { all } from 'redux-saga/effects';
import contactSaga from '../containers/ContactProfile/sagas';
import contactReferencesSaga from '../containers/CandidatePane/sagas';
import contactCandidatesSaga from '../containers/ReferencePane/sagas';
import prospectSaga from '../containers/ProspectPane/sagas';

export default function* contactProfileSaga() {
  yield all([
    contactSaga(),
    prospectSaga(),
    contactCandidatesSaga(),
    contactReferencesSaga()
  ]);
}
